module.exports = __webpack_public_path__ + "static/media/karvika_thapa.b5ae1f51.jpg";